import { InvestigationsAgentStatsResponse } from 'app/modules/investigations/types';

import { CASES_SLICE_NAME } from 'app/modules/cases/sliceCases';

import { createSelector } from 'reselect';
import {
  selectHasEditCasesPermission,
  selectHasReadAgentsPermissions,
  selectHasReadAssignmentsPermissions,
} from 'app/modules/session/selectors';

export const selectCases = (state: RootState) =>
  state[CASES_SLICE_NAME].cases || [];

export const selectAgentStats = (
  state: RootState,
): InvestigationsAgentStatsResponse => state[CASES_SLICE_NAME].agentStats;

// Loading
export const selectCreateCaseLoading = (state: RootState) =>
  state[CASES_SLICE_NAME].loadingCreateCase;

export const selectAdminCaseFilters = (state: RootState) =>
  state[CASES_SLICE_NAME].adminCaseFilters;

export const selectMyCaseFilters = (state: RootState) =>
  state[CASES_SLICE_NAME].myCaseFilters;

export const selectQueuedCaseFilters = (state: RootState) =>
  state[CASES_SLICE_NAME].queuedCaseFilters;

export const selectHasReassignCasePermission = createSelector(
  selectHasReadAgentsPermissions,
  selectHasEditCasesPermission,
  (hasReadAgentsPermission, hasEditCasesPermission) => {
    return hasReadAgentsPermission && hasEditCasesPermission;
  },
);

export const selectHasRequeueCasePermission = createSelector(
  selectHasReadAssignmentsPermissions,
  selectHasEditCasesPermission,
  (hasReadAssignmentsPermission, hasEditCasesPermission) => {
    return hasReadAssignmentsPermission && hasEditCasesPermission;
  },
);
